import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import EmployerPageFrame from "../../components/employer/EmployerPageFrame";
import { Button } from "../../components/ui/button";

export default function StbVerwaltung() {
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}/api/stb/employer/listings`)
      .then((response) => {
        setListings(Array.isArray(response.data) ? response.data : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fehler beim Laden der Anzeigen:", err);
        setError("Fehler beim Laden der Anzeigen.");
        setLoading(false);
      });
  }, []);

  const handleEdit = (id) => navigate(`/dashboard/stb/edit/${id}`);

  const handleDelete = async (id) => {
    if (!window.confirm("Soll diese Anzeige wirklich geloescht werden?")) return;
    try {
      await axios.delete(`${config.API_BASE_URL}/api/stb/suchanzeigen/${id}`);
      setListings((previous) => previous.filter((listing) => listing.id !== id));
    } catch (err) {
      console.error("Fehler beim Loeschen der Anzeige:", err);
      alert("Fehler beim Loeschen der Anzeige.");
    }
  };

  const handlePause = async (id) => {
    if (!window.confirm("Soll diese Anzeige pausiert werden?")) return;
    try {
      await axios.put(`${config.API_BASE_URL}/api/stb/suchanzeigen/${id}/pause`);
      setListings((previous) => previous.map((listing) => (
        listing.id === id ? { ...listing, status: "paused" } : listing
      )));
    } catch (err) {
      console.error("Fehler beim Pausieren der Anzeige:", err);
      alert("Fehler beim Pausieren der Anzeige.");
    }
  };

  return (
    <EmployerPageFrame
      title="Legacy Verwaltung"
      subtitle="Der aeltere Tabellenpfad bleibt fachlich erhalten, ist jetzt aber als voller Employer-Arbeitsraum lesbar statt als enger Dark-Block."
      actions={(
        <Button className="dashboard-action-button" onClick={() => navigate("/dashboard/employer")}>
          Zurueck zum Deck
        </Button>
      )}
      contentClassName="space-y-4"
    >
      {loading ? <p className="text-sm text-slate-500">Laedt...</p> : null}
      {error ? <p className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700">{error}</p> : null}

      {!loading ? (
        <section className="dashboard-card-shell">
          <div className="dashboard-section-head">
            <div>
              <span className="dashboard-kicker">Legacy Tabelle</span>
              <h2 className="dashboard-card-title">Anzeigenverwaltung</h2>
            </div>
          </div>

          <div className="overflow-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 text-left">ID</th>
                  <th className="px-4 py-3 text-left">Titel</th>
                  <th className="px-4 py-3 text-left">Status</th>
                  <th className="px-4 py-3 text-left">Erstellt am</th>
                  <th className="px-4 py-3 text-left">Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {listings.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-4 py-6 text-center text-slate-500">
                      Noch keine Stellenanzeigen angelegt.
                    </td>
                  </tr>
                ) : (
                  listings.map((listing) => (
                    <tr key={listing.id} className="border-t border-slate-200">
                      <td className="px-4 py-3">{listing.id}</td>
                      <td className="px-4 py-3">{listing.title}</td>
                      <td className="px-4 py-3">{listing.status}</td>
                      <td className="px-4 py-3">{listing.createdAt ? new Date(listing.createdAt).toLocaleDateString() : "-"}</td>
                      <td className="px-4 py-3">
                        <div className="flex flex-wrap gap-2">
                          <Button size="sm" variant="outline" className="dashboard-inline-button" onClick={() => handleEdit(listing.id)}>
                            Edit
                          </Button>
                          <Button size="sm" className="dashboard-action-button-danger" onClick={() => handleDelete(listing.id)}>
                            Loeschen
                          </Button>
                          <Button size="sm" className="dashboard-action-button-secondary" onClick={() => handlePause(listing.id)}>
                            Pausieren
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>
      ) : null}
    </EmployerPageFrame>
  );
}
